import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getIsLoadingByType, refuseExchangeOrder } from '@entities/exchange';
export function useRefuseExchange() {
    const dispatch = useDispatch();
    const isLoading = useSelector(getIsLoadingByType('refuse-exchange'));
    const onRefuseExchange = useCallback((payload) => {
        dispatch(refuseExchangeOrder(payload));
    }, [dispatch]);
    return { onRefuseExchange, isLoading };
}
